<template>
    <DCard
        padding
    >
        <Form
            :countries="countries"
            :errors="errors"
            :customer-types="customerTypes"
            :credit-note-types="creditNoteTypes"
            :effectiveness="effectiveness"
            :is-finance-system-netsuite="isFinanceSystemNetsuite"
            @form-submitted="submitData"
        />
    </DCard>
</template>

<script>
import Form from '~@/Components/Settings/TaxRulesCreditNotes/Form'

export default {
    name: 'TaxRuleCreate',
    components: {
        Form
    },
    props: {
        countries: {
            type: Array,
            default: () => { return [] }
        },
        customerTypes: {
            type: Array,
            default: () => { return [] }
        },
        errors: {
            type: Object,
            default: () => { return {} }
        },
        creditNoteTypes: {
            type: Array,
            default: () => { return [] }
        },
        effectiveness: {
            type: Array,
            default: () => []
        },
        isFinanceSystemNetsuite: {
            type: Boolean,
            default: () => { return false }
        }
    },
    methods: {
        submitData (form) {
            form.post(this.$route('settings.tax-rules-credit-notes.store'))
        }
    }
}
</script>
